import { useFormContext } from 'react-hook-form';

export const ConnectForm = ({ children }) => {
  const formMethods = useFormContext();
  return children({ ...formMethods });
};
